import styled from 'styled-components';

export const Container = styled.div`
	position: relative;
	width: 100%;
	height: 85px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	border-radius: 10px;
	overflow: hidden;
`;

export const Left = styled.div`
	width: 100%;
	height: 85px;
	display: flex;
	align-items: center;
	justify-content: left;
	background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)),
		linear-gradient(180deg, #5d36ae 0%, #452c92 100%);
	font-weight: 700;
	font-size: 22px;
	line-height: 24px;
	letter-spacing: 0.37px;
	color: #ff5d70;
	padding-left: 10px;
`;

export const Right = styled.div`
	width: 100%;
	height: 85px;
	display: flex;
	align-items: center;
	justify-content: right;
	background: linear-gradient(180deg, #5d36ae 0%, #452c92 100%);
	font-weight: 700;
	font-size: 22px;
	line-height: 24px;
	letter-spacing: 0.37px;
	color: #d9fc78;
	padding-right: 10px;
	text-align: end;
`;

export const Date = styled.div`
	font-weight: 400;
	font-size: 10px;
	line-height: 16px;
	color: #ffffff;
	opacity: 0.5;
`;

export const Arrows = styled.img`
	margin-top: 10px;
	width: ${({ width }) => width};
	height: ${({ height }) => height};
`;

export const MonthPlan = styled.img`
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);
	width: 40px;
`;
